<div class="pop" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <header>
    <ng-container *ngIf="selectedIndex===stepperIndex.voucher">
      <h3 langkey="voucher_title"></h3>
      <div class="voucher-content__info">
        <div class="voucher__balance">
          <h1 class="text-content" langkey="voucher_data_no"></h1>
          <h1 class="amount">{{replaceVoucherChar}}</h1>
        </div>
        <ng-container *ngIf="allowVoucherPay">
          <div class="voucher__balance">
            <h1 class="text-content" langkey="voucher_data_value"></h1>
            <h1 class="amount">{{voucher.Amount | price}}</h1>
          </div>
          <ng-container *ngIf="hasValue(voucher.InviteAmount)">
            <div class="voucher__balance">
              <h1 class="text-content" langkey="voucher_data_invite_value"></h1>
              <h1 class="amount">{{voucher.InviteAmount | price}}</h1>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="hasValue(voucher.Discount)">
          <div class="voucher__balance">
            <h1 class="text-content" langkey="voucher_data_discount"></h1>
            <h1 class="amount discount">{{voucher.Discount}}</h1>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="selectedIndex===stepperIndex.payment">
      <h3 langkey="voucher_pay_title"></h3>
    </ng-container>
  </header>
  <div class="content">
    <div class="process">
      <mat-horizontal-stepper #stepper [linear]="true" [selectedIndex]="selectedIndex" [class.hideSteps]="false"
        [class.single-option-padding]="!allowVoucherPay || !useBonussystem">
        <ng-template matStepperIcon="edit" let-index="index">
          {{index + 1}} <!-- Completed && editiable && Not Selected Step;  -->
        </ng-template>
        <ng-template matStepperIcon="done" let-index="index">
          {{index + 1}} <!-- Completed && editable && Not Selected;  -->
        </ng-template>
        <ng-template matStepperIcon="number" let-index="index">
          {{index + 1}} <!-- Selected || Not Completed;  -->
        </ng-template>
        <ng-container>
          <mat-step>
            <div class="voucher-content" [class.single-option--margin]="!allowVoucherPay || !useBonussystem">
              <p langkey="voucher_options_info"></p>
              <ng-container *ngIf="allowVoucherPay && useBonussystem">
                <span class="select-option" langkey=voucher_select_option></span>
              </ng-container>
              <div class="voucher-option__list" [class.single-option]="!(allowVoucherPay && useBonussystem)">
                <ng-container *ngIf="allowVoucherPay && useBonussystem">
                  <div class="option">
                    <a class="btn insert" [class.action]="selectedVoucherOption === voucherOptions.payAndBonus"
                      (click)="setVoucherOption(voucherOptions.payAndBonus)">
                      <span langkey="voucher_pay_and_bonus"></span>
                    </a>
                  </div>
                </ng-container>
                <ng-container *ngIf="allowVoucherPay && !useBonussystem">
                  <div class="option">
                    <a class="btn insert" [class.action]="selectedVoucherOption === voucherOptions.onlyPay"
                      (click)="setVoucherOption(voucherOptions.onlyPay)">
                      <span langkey="voucher_pay"></span>
                    </a>
                  </div>
                </ng-container>
                <ng-container *ngIf="useBonussystem">
                  <div class="option">
                    <a class="btn insert" [class.action]="selectedVoucherOption === voucherOptions.onlyBonus"
                      (click)="setVoucherOption(voucherOptions.onlyBonus)">
                      <span langkey="voucher_bonus"></span>
                    </a>
                  </div>
                </ng-container>
              </div>
            </div>
          </mat-step>
          <mat-step>
            <div class="payment-content" [class.animate]="animateContent">
              <h3 langkey="voucher_pay_type"></h3>
              <div class="payment-options">
                <ng-container *ngIf="allowTerminalPay && allowPosPay">
                  <span class="select-option" langkey="voucher_select_pay_type"></span>
                </ng-container>
                <div class="payment">
                  <a *ngIf="allowTerminalPay" class="btn pay" (click)="selectedPaymentOptions(paymentType.ecTerminal)">
                    <span langkey="voucher_pay_type_terminal"></span>
                    <div inlineSVG="sot/sot-icon.svg#sot-pay_at_terminal" flex
                      [setSVGAttributes]="{class: 'aside-icon'}"></div>
                  </a>
                  <a *ngIf="allowPosPay" class="btn pay" (click)="selectedPaymentOptions(paymentType.atPOS)">
                    <span langkey="voucher_pay_type_pos"></span>
                    <div inlineSVG="sot/sot-icon.svg#sot-pay_at_pos" flex [setSVGAttributes]="{class: 'aside-icon'}">
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </mat-step>
        </ng-container>
      </mat-horizontal-stepper>
    </div>
    <ng-container *ngIf="hasSomeBalance() then customized else noBalance"></ng-container>
    <ng-template #noBalance>
      <div class="sum-content ">
        <ng-container *ngIf="hasValue(tipPercent)">
          <div class="sum-info">
            <div class="sum-detail">
              <h1 class="text-content" langkey="voucher_overview_tip"></h1>
              <h1 class="amount sum-label">{{tipAmount | price}}</h1>
            </div>
          </div>
        </ng-container>
        <div class="sum-detail">
          <h1 class="text-content" langkey="voucher_overview_sum_total"></h1>
          <h1 class="amount sum-label">{{sumTotal | price}}</h1>
        </div>
      </div>
    </ng-template>
    <ng-template #customized>
      <div class="sum-content ">
        <div class="sum-info">
          <ng-container *ngIf="hasValue(voucher.Discount)">
            <div class="sum-detail">
              <h1 class="text-content" langkey="voucher_overview_discount"></h1>
              <div class="discount-info">
                <h1 class="sum-discount">{{basketPriceWithoutDiscount | price}}</h1>
                <h1 class="sum-label">{{basketPrice | price}}</h1>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="hasValue(tipPercent)">
            <div class="sum-detail">
              <h1 class="text-content" langkey="voucher_overview_tip"></h1>
              <h1 class="amount sum-label">{{tipAmount | price}}</h1>
            </div>
          </ng-container>
          <ng-container *ngIf="selectedVoucherOption !==''">
            <ng-container
              *ngIf="selectedVoucherOption === voucherOptions.payAndBonus || selectedVoucherOption === voucherOptions.onlyPay">
              <ng-container *ngIf="hasValue(voucher.Amount) || hasValue(voucher.InviteAmount)">
                <div class="sum-detail">
                  <h1 class="text-content" langkey="voucher_overview_use_amount"></h1>
                  <h1 class="amount sum-label sum-voucher__balance">{{voucherBalace | price}}</h1>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
        <div class="sum-detail sum-total">
          <h1 class="text-content" langkey="voucher_overview_sum_total"></h1>
          <ng-container
            *ngIf="selectedVoucherOption === voucherOptions.payAndBonus || selectedVoucherOption === voucherOptions.onlyPay">
            <h1 class="amount sum-label">{{remainingAmount | price}}</h1>
          </ng-container>
          <ng-container *ngIf="selectedVoucherOption === '' || selectedVoucherOption === voucherOptions.onlyBonus">
            <h1 class="amount sum-label">{{sumTotal | price}}</h1>
          </ng-container>
        </div>
      </div>
    </ng-template>
  </div>
  <footer class="buttons" [class.singleBtn]="selectedIndex === stepperIndex.payment">
    <a class="btn goback insert" (click)="cancel()">
      <div inlineSVG="sot/sot-icon.svg#sot-close" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
      <span langkey="button_cancel"></span>
    </a>
    <ng-container *ngIf="selectedIndex===stepperIndex.voucher">
      <a class="btn goforward" [class.disabled]="selectedVoucherOption === ''" (click)="continue()">
        <span langkey="button_continue"></span>
        <div inlineSVG="sot/sot-icon.svg#sot-forward" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
      </a>
    </ng-container>
  </footer>
</div>